module.exports = __webpack_public_path__ + "img/register.618df011.svg";